module.exports = __webpack_public_path__ + "img/fourwaves-light-full.1dd68c9.png";